import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import RequirePermission from "components/util-components/RequirePermission";
import { PERMISSIONS } from "functions/permissions";
import Users from "./users";
import Groups from "./groups";
import Collections from "./collections";
import Roles from "./roles";

const PARENT_URL = "/cms/admin";

// Tot BMX-35 was dit alleen uit het menu verborgen voor niet-admins; de URL
// intypen werkte gewoon. Nu per pagina bewaakt.
const Admin = () => (
  <Suspense fallback={<Loading cover="content" />}>
    <Routes>
      <Route
        path={`/users`}
        element={
          <RequirePermission permission={PERMISSIONS.ADMIN_USERS}>
            <Users />
          </RequirePermission>
        }
      />
      <Route
        path={`/roles`}
        element={
          <RequirePermission permission={PERMISSIONS.ADMIN_USERS}>
            <Roles />
          </RequirePermission>
        }
      />
      <Route
        path={`/groups`}
        element={
          <RequirePermission permission={PERMISSIONS.ADMIN_GROUPS}>
            <Groups />
          </RequirePermission>
        }
      />
      <Route
        path={`/collections`}
        element={
          <RequirePermission permission={PERMISSIONS.ADMIN_COLLECTIONS}>
            <Collections />
          </RequirePermission>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/users`} replace />} />
    </Routes>
  </Suspense>
);

export default Admin;
